import * as React from 'react'
import { MenuItem, Position, Intent } from '@blueprintjs/core'
import { Select2 } from '@blueprintjs/select'
import { Button } from '@ui'
import { IUIButtonProps } from '@ui/buttons/Button'
import { TicketPriority } from '@api/types'

interface PrioritySelectProps {
  buttonProps?: IUIButtonProps
  placeholder?: string
  value: TicketPriority
  onChange: (status: TicketPriority) => void
}

const intents = {
  [TicketPriority.CRITICAL]: Intent.DANGER,
  [TicketPriority.HIGH]: Intent.DANGER,
  [TicketPriority.MEDIUM]: Intent.WARNING,
  [TicketPriority.LOW]: undefined,
  [TicketPriority.INFO]: undefined,
}

const PrioritySelect = Select2<TicketPriority>

export default function PrioritySelectWrapper({
  value,
  placeholder,
  onChange,
  buttonProps,
}: PrioritySelectProps) {
  const capitalize: React.CSSProperties = { textTransform: 'capitalize' }
  const _buttonProps = buttonProps
    ? {
        ...buttonProps,
        style: { ...buttonProps.style, ...capitalize },
      }
    : { style: capitalize }

  return (
    <PrioritySelect
      popoverProps={{
        position: Position.BOTTOM,
        minimal: true,
      }}
      filterable={false}
      items={Object.values(TicketPriority)}
      itemRenderer={(priority, { handleClick }) => (
        <MenuItem
          style={capitalize}
          key={priority}
          active={value === priority}
          onClick={handleClick}
          text={priority}
          data-item={priority}
        />
      )}
      onItemSelect={onChange}
    >
      <Button
        ghost
        minimal
        {..._buttonProps}
        intent={value ? intents[value] : undefined}
        text={value || placeholder || 'Select'}
      />
    </PrioritySelect>
  )
}
